import React from 'react';
import loadable from '@loadable/component';
import connectRoute from 'app/routes/connectRoute';
import RedirectActions from 'app/actions/RedirectActions';
import SearchActions from 'app/actions/SearchActions';
import { currentLibrarySelector } from 'app/selectors/LibrarySelector';

const SearchContainer = loadable(() => import('app/components/search/Search/SearchContainer'));

export function SearchPageRoute() {
  return <SearchContainer />;
}

function getRouteData({ state, dispatch, location, query }) {
  const library = currentLibrarySelector(state);
  const catalogSearch = state.getIn(['search', 'catalogSearch']);
  const view = catalogSearch.get('view');
  const searchType = catalogSearch.get('searchType');
  const searchQuery = catalogSearch.get('query');
  const isInitialSearch = !searchType || !searchQuery;

  // If `defaultSearchToOnlineBibs` is enabled, filter new searches (excluding
  // advanced searches), to display only online bibs by default.
  if (library.get('defaultSearchToOnlineBibs')) {
    const isNewSearch = isInitialSearch || searchQuery !== query.query;
    if (isNewSearch && query.query && !query.f_CIRC && query.searchType !== 'bl') {
      return [dispatch(RedirectActions.redirect(`${location.pathname}${location.search}&f_CIRC=ONLINE`))];
    }
  }

  // Shelf availability search
  // NOTE: The shelf availability endpoint is considered a little expensive.
  // For this reason, we only use the shelf availability endpoint only on the
  // initial search, when we don't know the searchType or search query.
  if (isInitialSearch && query.shelf) {
    return [dispatch(SearchActions.performShelfAvailabilitySearch({ ...query, view }))];
  }

  // Regular catalog search
  return [dispatch(SearchActions.performCatalogSearch({ query: searchQuery, searchType, ...query, view }))];
}

export default connectRoute(SearchPageRoute, {
  getRouteData,
  debounceOptions: {
    wait: 100 // milliseconds
  }
});
